import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'listCount': 0,
  'detail': [],
  'filters': {
    'dateFrom': '',
    'dateTo': '',
    'partCode': '',
    'orderCode': '',
    'dealer': '',
    'abis_status': '',
    'status_alerts': '',
    'provider': '31',
  },
};


export const dealerOrdersEtaManagement = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'detail': [],
    }),
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'listCount': action.response.count,
      'detail': [],
    }),
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'listCount': 0,
      'detail': [],
    }),
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'detail': [],
    }),
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'detail': action.response.data,
    }),
    [ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'detail': [],
    }),
    [ActionTypes.EDIT_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS]: (state, action) => ({
      ...state,
      'filters': {...state.filters, [action.payload.field]: action.payload.value},
    }),
    [ActionTypes.CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS]: (state, action) => ({
      ...state,
      'filters': {
        ...state.filters,
        'dateFrom': '',
        'dateTo': '',
        'partCode': '',
        'orderCode': '',
        'dealer': '',
        'abis_status': '',
        'status_alerts': '',
      },
    }),
    [ActionTypes.CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_DATA]: (state, action) => ({
      ...state,
      'list': [],
      'listCount': 0,
    }),
  })(state, action);
};
